<template>
  <div class="compare_plan_container">
    <el-button type="primary" @click="addComparisonGroup(0)" v-if="list_data.length < 1">添加对照组</el-button>
    <el-divider v-if="list_data.length < 1">暂无数据</el-divider>
    <div class="single_plan" v-for="(item, index) in list_data" :key="index">
      <div class="input_box">
        <label for="plan_name" class="plan_name">比较组名称：</label>
        <el-input v-model="list_data[index].label" placeholder="比较组方案名称" style="width: 200px;"></el-input>
        <label for="plan_name" class="plan_name" style="margin-left: 10px;">比较组方法：</label>
        <el-select v-model="list_data[index].method" placeholder="请选择" class="compare_group_select">
          <el-option v-for="e in method_list" :key="e.value" :label="e.label" :value="e.value"
            :disabled="methodDisabled(e,index)">
          </el-option>
        </el-select>
      </div>
      <div class="comparison_group">
        <div class="group_container">
          <label for="plan_name" class="plan_name">比较组设置：</label>
          <div class="compare_group_container">
            <div class="group_item" v-for="(g_e, g_i) in item.value" :key="g_i">
              <div class="compare_group">
                <div class="compare_group_title">
                  <span v-if="g_i==0">实验组(分子)</span>
                  <span v-else-if="g_i==1">对照组(分母)</span>
                  <span v-else>对照组</span>
                </div>
                <el-select v-model="list_data[index].value[g_i]" placeholder="请选择" class="compare_group_select">
                  <el-option v-for="item in group_list" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="vs_icon" v-if="g_i!== item.value.length - 1" title="vs">
                <i class="el-icon-sort rotation_icon"></i>
              </div>
            </div>
            <div class="add_group_btn" title="添加对照项" @click="addComparisonGroupItem(index)">
              <el-icon>
                <Plus />
              </el-icon>
            </div>
            <div class="add_group_btn" title="删除对照项" @click="removeComparisonGroupItem(index)">
              <el-icon>
                <Minus />
              </el-icon>
            </div>

          </div>
        </div>

      </div>

      <div class="handle_btn_box">
        <el-button type="text" title="添加对照组" @click="addComparisonGroup(index)">
          <!-- <i class="el-icon-circle-plus-outline"></i> -->
          <el-icon>
            <CirclePlus />
          </el-icon>
        </el-button>
        <el-button type="text" title="删除对照组" @click="removeComparisonGroup(index)">
          <!-- <i class="el-icon-remove-outline" style="color: #F56C6C;"></i> -->
          <el-icon style="color: #F56C6C;">
            <Remove />
          </el-icon>
        </el-button>
      </div>


    </div>
  </div>
</template>
<script setup>
  import { ref, defineProps, watch, onBeforeMount, onMounted, onBeforeUpdate, onUpdated, onBeforeUnmount, onUnmounted, defineEmits } from 'vue';
  import { ElMessage } from 'element-plus';

  const emit = defineEmits(['updateComparePlan'])
  const props = defineProps(['rawData', 'compareData', 'configData']);

  const list_data = ref([]);//方案列表
  const group_list = ref([]);//分组列表
  const method_list = ref([]);//比较方法列表


  const getGroupList = function (rawData, mappings) {
    const sampleItem = mappings.find(item => item.fixed_key === 'sample');
    const groupItem = mappings.find(item => item.fixed_key === 'group');
    const samplenameItem = mappings.find(item => item.fixed_key === 'samplename');
    if (!sampleItem || !groupItem || !samplenameItem) return ElMessage.error('映射配置错误，请检查！');
    const groupList = rawData
      .map(item => item[groupItem.key]) // 提取 group 字段
      .filter(group => group) // 过滤掉空值
      .filter((value, index, self) => self.indexOf(value) === index) // 去重
      .map(group => ({ label: group, value: group })); // 转换为选择项结构
    return groupList;
  };

  const transformData = function (compareData, mapping) {// 转换数据格式
    return compareData.map(item => {
      const label = item[mapping.label];
      const tag = item[mapping.value];
      const method = item[mapping.method];
      const value = tag.split('_vs_').map(value => value.trim());
      return { label, value, method };
    });
  };

  const transformBackToRawData = function (transformedData, mapping) { // 转换回原始数据格式
    return transformedData.map(item => {
      const label = item.label;
      const tag = item.value.join('_vs_');
      const method = item.method;
      return { [mapping.label]: label, [mapping.value]: tag, [mapping.method]: method };
    });
  };

  const addComparisonGroup = function (index) { // 添加比较组
    list_data.value.splice(index + 1, 0, { label: '', value: [''] })
  };

  const removeComparisonGroup = function (index) { // 删除比较组
    list_data.value.splice(index, 1);
  };

  const addComparisonGroupItem = function (index) { // 添加比较组项
    list_data.value[index].value.push('');
    list_data.value[index].method = '';
  };

  const removeComparisonGroupItem = function (index) { // 删除比较组项
    list_data.value[index].value.pop();
    list_data.value[index].method = '';
  };

  const methodDisabled = function (item, index) { // 禁用比较方法
    const { max_count } = item;
    const cell_length = list_data.value[index].value.length;
    if (cell_length == 2 && max_count == 2) {
      return false;
    } else if (cell_length > 2 && max_count > 2) {
      return false;
    };
    return true;
  };

  const validateData = function (data, config) { // 验证数据格式
    if (data.length < 1) {
      ElMessage.error('无数据，请完善方案！');
      return false;
    };
    const labels = data.map(item => item.label);//需要确保 label 不重复
    if (new Set(labels).size !== labels.length) {
      const repeatName = labels.filter((item, index) => labels.indexOf(item) !== index);
      ElMessage.error(`方案名称 ${repeatName.join(',')} 重复！`);
      return false;
    };
    for (const { label, value, method } of data) {
      if (!label) { // 方案名称
        ElMessage.error('请完善方案名称！');
        return false;
      };
      if (value.length < 2) { // 至少两个分组
        ElMessage.error('请选择两个或两个以上分组！');
        return false;
      };
      //value 是这样的 ["A","B",""]，不能有空字符串
      if (value.some(item => item.trim() === '')) {
        ElMessage.error(`方案 ${label} 存在空选项！`);
        return false;
      };
      //value 是这样的 ["A","B",""]，不能存在重复项
      if (value.some((item, index, self) => self.indexOf(item.trim()) !== index)) {
        ElMessage.error(`方案 ${label} 存在重复选项！`);
        return false;
      };
      if (!method) {// method 必须在 存在
        ElMessage.error(`请选择方案 ${label} 的比较方法！`);
        return false;
      };
    }
    return true;
  };

  const updateHandle = function () { // 更新比较方案
    const flag = validateData(list_data.value, props.configData.plan_config);
    if (!flag) return;
    const compareData = transformBackToRawData(list_data.value, props.configData.plan_mapping);
    emit('updateComparePlan', compareData);
  };


  // 使用 watch 监听 props 的字段变化
  watch(() => props, (newData, oldData) => {
  });
  //组件即将挂载
  onBeforeMount(() => {
  });
  //组件已经挂载
  onMounted(() => {
    const { group_senior_mapping, plan_mapping, plan_config } = props.configData;
    method_list.value = plan_config['methods'] || [];//比较方法列表
    list_data.value = transformData(props.compareData, plan_mapping);


    console.log("方案数据", list_data.value);


    console.log("group_senior_mapping是什么", group_senior_mapping);
    console.log("props.rawData是什么", props.rawData);

    group_list.value = getGroupList(props.rawData, group_senior_mapping);
  });
  //组件即将更新
  onBeforeUpdate(() => {
  });
  //组件已经更新
  onUpdated(() => {
  });
  //组件即将卸载
  onBeforeUnmount(() => {
  });
  //组件已经卸载
  onUnmounted(() => {
  });

  defineExpose({
    updateHandle
  });
</script>
<style scoped>
  .compare_plan_container {
    max-height: 600px;
    overflow-y: auto;
    box-sizing: border-box;
    padding-right: 10px;
  }

  .compare_plan_container .compare_plan_container {
    max-height: 500px;
    overflow-y: auto;
  }

  .compare_plan_container .single_plan {
    /* display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 10px; */
    position: relative;
    margin-bottom: 10px;
    padding: 10px;
    box-sizing: border-box;
    border: 1px solid #DCDFE6;
    border-radius: 4px;
  }

  .compare_plan_container .single_plan:hover {
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  }

  .compare_plan_container .input_box {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    margin-bottom: 10px;
  }

  .compare_plan_container .plan_name {
    text-align: right;
    padding-top: 5px;
    font-weight: bold;
  }

  .compare_plan_container .compare_group {
    position: relative;
    padding-left: 91px;
    display: inline-block;
  }

  .compare_plan_container .compare_group_title {
    position: absolute;
    left: 0;
    top: 0;
    width: 90px;
    height: 100%;
    border: 1px solid #DCDFE6;
    border-radius: 4px;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .compare_plan_container .compare_group_select {
    width: 140px;
    margin-left: -5px;
  }

  .compare_plan_container .vs_icon {
    display: inline-block;
    margin: 0 15px;
  }

  .compare_plan_container .rotation_icon {
    transform: rotate(90deg);
  }

  .compare_plan_container .compare_group_container {
    flex: 1;
  }

  .compare_plan_container .comparison_group {
    flex: 1;
    margin-bottom: 10px;
  }

  .compare_plan_container .group_container {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
  }

  .compare_plan_container .group_item {
    display: inline-block;
    vertical-align: middle;
    margin-bottom: 10px;
  }

  .compare_plan_container .handle_btn_box {
    position: absolute;
    right: 10px;
    top: 10px;
    display: none;
  }

  .compare_plan_container .single_plan:hover .handle_btn_box {
    display: block;
    transition: all 0.3s ease-in-out;
  }

  .compare_plan_container .add_group_btn {
    width: 20px;
    height: 20px;
    border: 2px solid #DCDFE6;
    box-sizing: border-box;
    cursor: pointer;
    display: inline-block;
    vertical-align: middle;
    margin-bottom: 10px;
    margin-left: 10px;
    text-align: center;
  }
</style>